import React, { Component } from 'react'
import styles from "./MaskWrapper.module.css"

const LT_DIR = "LEFT_TOP_DIRECTION"
const RB_DIR = "RIGHT_BOTTOM_DIRECTION"
const RT_DIR = "RIGHT_TOP_DIRECTION"
const LB_DIR = "LEFT_BOTTOM_DIRECTION"
export default class MaskWrapper extends Component {
    constructor(props) {
        super(props)
        this.state = {
            direction: null,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
            borderBottom: 0,
            visibility: "visible",
        }
    }

    // handler
    hoverLeave = (e) => {
        this.setState(state => { return { visibility: "hidden" } })
    }
    hoverEnter = (e) => {
        this.setState(state => { return { visibility: "visible" } })
    }
    triggerHandler = (e, dir) => {
        this.setState(state => { return { direction: dir } })

        //todo: callback to notify it has been triggered
        if (this.props.maskTriggerCallback)
            this.props.maskTriggerCallback(true)
    }

    moveEvaluationFunc = (e, dir) => {
        if (this.node == null)
            return
        const { top, left, right, bottom, width, height } = this.node.getBoundingClientRect() //reference to viewport

        var borderTop = (e.clientY - top > 0) ? (e.clientY - top) : 0
        var borderLeft = (e.clientX - left > 0) ? (e.clientX - left) : 0
        var borderRight = (right - e.clientX > 0) ? (right - e.clientX) : 0
        var borderBottom = (bottom - e.clientY > 0) ? (bottom - e.clientY) : 0

        if (dir == LT_DIR)
            this.setState(state => { return { borderTop: borderTop, borderLeft: borderLeft } })
        if (dir == RB_DIR)
            this.setState(state => { return { borderRight: borderRight, borderBottom: borderBottom } })
        if (dir == RT_DIR)
            this.setState(state => { return { borderRight: borderRight, borderTop: borderTop } })
        if (dir == LB_DIR)
            this.setState(state => { return { borderLeft: borderLeft, borderBottom: borderBottom } })
    }
    // lifecycle
    componentDidMount() {
        document.addEventListener("mousemove", (e) => {
            if (this.state.direction != null) {
                this.moveEvaluationFunc(e, this.state.direction)
            }
        })
        document.addEventListener("mouseup", (e) => {
            this.setState(state => { return { direction: null } })
            if (this.props.maskTriggerCallback)
                this.props.maskTriggerCallback(false)
        })
    }

    render() {
        const iconStyle = { visibility: (this.props.select) ? this.state.visibility : "hidden" }

        const maskStyle = {
            borderTop: `${this.state.borderTop}px solid lightcoral`,
            borderLeft: `${this.state.borderLeft}px solid lightcoral`,
            borderRight: `${this.state.borderRight}px solid lightcoral`,
            borderBottom: `${this.state.borderBottom}px solid lightcoral`,
        }
        return (
            <div className={styles.container} style={maskStyle} ref={(ref) => { this.node = ref }}
                onMouseLeave={this.hoverLeave}
                onMouseEnter={this.hoverEnter}>
                <div className={styles.leftTopIcon} style={iconStyle} onMouseDown={(e) => { this.triggerHandler(e, LT_DIR) }}></div>
                <div className={styles.rightBottomIcon} style={iconStyle} onMouseDown={(e) => { this.triggerHandler(e, RB_DIR) }}></div>
                <div className={styles.rightTopIcon} style={iconStyle} onMouseDown={(e) => { this.triggerHandler(e, RT_DIR) }}></div>
                <div className={styles.leftBottomIcon} style={iconStyle} onMouseDown={(e) => { this.triggerHandler(e, LB_DIR) }}></div>
            </div>
        )
    }
}
